// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardRequestListController {
   $filter: any
   $log: any
   $q: any
   $scope: any
   $uibModal: any
   alerts: any
   allSelected: any
   apiService: any
   docs: any
   emptyListMessage: any
   error: any
   i18n: any
   isLoading: any
   rawBibIds: any
   selectedCount: any
   sierraService: any
   sortOptionSelected: any
   sortOptions: any
   success: any
   userInfo: any
   libraryCardErrorHelper: any
   constructor($scope: any, sierraService: any, apiService: any, translationService: any, alertService: any, $q: any, $log: any, $uibModal: any, $filter: any, $rootScope: any, $authEvents: any, libraryCardErrorHelper: any) {
      this.$onInit = this.$onInit.bind(this)
      this.$onChanges = this.$onChanges.bind(this)
      this.loadHolds = this.loadHolds.bind(this)
      this.updateSelected = this.updateSelected.bind(this)
      this.toggle = this.toggle.bind(this)
      this.cancelHold = this.cancelHold.bind(this)
      this.cancelSelectedHolds = this.cancelSelectedHolds.bind(this)
      this.$scope = $scope
      this.sierraService = sierraService
      this.apiService = apiService
      this.$q = $q
      this.$log = $log
      this.$uibModal = $uibModal
      this.$filter = $filter
      this.i18n = translationService
      this.isLoading = false
      this.docs = []
      this.rawBibIds = []
      this.selectedCount = 0
      this.allSelected = false
      this.sortOptions = [ 
         { sortBy: 'doc.full_title', translation: translationService.translations.TITLE, dateOrCode: true },
         { sortBy: 'requestDate', translation: translationService.translations.REQUEST_DATE, dateOrCode: true },
         { sortBy: 'pickupLocation', translation: translationService.translations.PICKUP_LOCATION, dateOrCode: false }
      ]
      this.sortOptionSelected = { sortBy: '', translation: '', dateOrCode: false }
      this.alerts = alertService
      this.userInfo = this.sierraService.getLoadedUserInfo()
      this.libraryCardErrorHelper = libraryCardErrorHelper

      $rootScope.$on($authEvents.LOGOUTSUCCESS, () => this.docs = [])
   }

   $onInit() {
      this.loadHoldsWhenReady()      
   }

   $onChanges(changesObj: any) {
      // reload requests if explicit trigger fired or a new request has been made
      if (changesObj.reloadTrigger?.currentValue || changesObj.newRequestMade?.currentValue) {
         return this.loadHoldsWhenReady()
      }
   }

   loadHoldsWhenReady(){
      this.isLoading = true
      return this.sierraService.patronInfoLoadedPromise.promise
         .then(() => this.loadHolds())
         .catch((err: any) => this.handleError(err))
   }

   loadHolds() {
      // offer possibility of choosing pickup location unless config explicitly indicates otherwise
      const itemOrBibIsEditable = (recordType: any) => {
         const itemOrBib = recordType === 'i' ? 'item' : 'bib'
         return !(this.userInfo?.holdConfig?.[itemOrBib]?.useHomePickupLocation || this.userInfo?.holdConfig?.[itemOrBib]?.useItemPickupLocation)
      }
    
      this.isLoading = true
      return this.sierraService
         .getHolds()
         .then((resp: any) => {
            if (resp.data?.entries == null) {
               throw { data: {message: 'API response empty.'} }
            }
            const itemIdRecords = _.filter(resp.data.entries, (entry: any) => entry.recordType === 'i')
            const itemIds = _.map(itemIdRecords, (item: any) => item.record.id)
            if (itemIds.length > 0) {
               return this.sierraService.getItemsInfo(itemIds)
                  .then((itemResp: any) => { 
                     if (itemResp.data?.entries == null) {
                        return this.$q.resolve(resp)
                     }
                     // here 'volume' info is added to the items if it can be found
                     _.each(itemIdRecords, (itemRecord: any) => { 
                        const matchingItem = _.find(itemResp.data.entries, (item: any) => { 
                           return itemRecord.record.id === item.id
                        })
                        if (matchingItem) {
                           // grab volume info (in 'fieldTag == 'v'')
                           const volume = _.find(matchingItem.varFields, (i: any) => i.fieldTag === 'v')
                           if (volume) {
                              return itemRecord.volume = volume.content
                           }
                        }
                     })
                     // now resolve it
                     return this.$q.resolve(resp)
                  }).catch((err: any) => {
                     this.$log.debug('error grabbing item info, ignoring and will continue', err)
                     return this.$q.resolve(resp)
                  })
            } else {
               return this.$q.resolve(resp)
            }
         }).then((resp: any) => {
            this.sierraService.resetNewRequestTracker()
            this.rawBibIds = _.chain(resp.data.entries)
               .map((item: any) => ({
                  bibId: item.record.bibIds ? item.record.bibIds[0] : item.record.id,
                  recordId: item.record.id,
                  pickupLocation: item.pickupLocation,
                  holdId: item.id,
                  status: item.status.code,
                  requestDate: item.placed,
                  volume: item.volume,
                  record: item.record,
                  locationEditable: itemOrBibIsEditable(item.recordType)
               }))
               .value()

            if (this.sierraService.previousHoldRequestId) {
               // check if the previous hold is already in the response, if not show a message
               const idInResponse = _.filter(this.rawBibIds, (rawBibId: any) => rawBibId.bibId === this.sierraService.previousHoldRequestId)
               if (idInResponse.length === 0) {
                  this.success = this.i18n.translations.REQUESTS_MAY_NOT_BE_UP_TO_DATE
                  this.alerts.setAlert('libraryCardSuccess', this.success)
               } else {
                  this.sierraService.previousHoldRequestId = null
               }
            }

            const apiQuery = this.sierraService.createApiQuery(this.rawBibIds)
        
            if (apiQuery) {
               return this.apiService.get('search', apiQuery, {avoidUpdateFire: true})
            }
         }).then((resp: any) => {
            if (resp && resp.data) {
               return this.docs = _.map(this.rawBibIds, (sierraRequestDoc: any) => {
                  const {
                     locationEditable
                  } = sierraRequestDoc
                  const pickupLocation = sierraRequestDoc.pickupLocation.name
                  const holdId = this.sierraService.getIdFromUrlString(sierraRequestDoc.holdId)
                  let doc = this.sierraService.findDocIfExists(resp.data.documents, sierraRequestDoc.bibId) || this.sierraService.findDocIfExists(resp.data.documents, sierraRequestDoc.recordId) 
                  if (!doc) {
                     // create fallback document from the response if it exists
                     if (sierraRequestDoc.record?.title) {
                        const contentType = sierraRequestDoc.record.materialType ? sierraRequestDoc.record.materialType.value : '' 
                        doc = { 
                           content_type: contentType,
                           display_thumbnail: '',
                           full_title: sierraRequestDoc.record.title,
                           authors: sierraRequestDoc.record.author ? [{fullname: sierraRequestDoc.record.author}] : undefined,
                           summary: sierraRequestDoc.record.publishYear
                        }
                     } else {
                        doc = this.sierraService.createDummyDoc(this.i18n.translations.NO_RESOURCE_FOUND)
                     }
                  }

                  if (sierraRequestDoc.volume && !doc.missingDocDisplay) {
                     // adding volume info to title
                     doc =  angular.copy(doc)
                     if (doc.full_title) {
                        doc.full_title += ' - ' + sierraRequestDoc.volume
                     } else if (doc.title) {
                        doc.full_title = doc.title + ' - ' + sierraRequestDoc.volume
                     } else {
                        doc.full_title = 'Unknown - ' + sierraRequestDoc.volume
                     }
                  }
              
                  return { doc, pickupLocation, locationEditable, holdId, bibId: sierraRequestDoc.bibId, requestDate: sierraRequestDoc.requestDate }
               })
            } else {
               return this.docs = []
            }
         }) // no response

         .then(() => {
            if ((this.docs.length === 0) && (this.success !== this.i18n.translations.REQUESTS_MAY_NOT_BE_UP_TO_DATE)) {
               this.emptyListMessage = this.i18n.translations.REQUESTS_EMPTY
            } else {
               this.sortList()
            }
            this.isLoading = false
            return this.updateSelected()
         }).catch((err: any) => {
            return this.handleError(err)
         })
   }

   handleError(err: any) {
      this.$log.error(err)
      this.isLoading = false
      const errorMessage = this.libraryCardErrorHelper.getLibraryCardErrorMessage(err, this.sierraService, this.i18n)
      this.error = this.i18n.translate(this.i18n.translations.REQUESTS_ERROR, {error: errorMessage})
      return this.alerts.setAlert('libraryCardListLoadError', this.error)
   }

   showEmptyListMessage() {
      return (this.success !== this.i18n.translations.REQUESTS_MAY_NOT_BE_UP_TO_DATE) && !this.isLoading && !this.docs.length && !this.error
   }

   sortList(sortOption = this.sortOptions[0]) {
      this.sortOptionSelected = sortOption
      return this.docs = sortOption.dateOrCode ? this.$filter('orderBy')(this.docs, sortOption.sortBy) : this.$filter('localeSort')(this.docs, sortOption.sortBy)
   }

   getSortByOption() {
      return this.sortOptionSelected.translation
   }

   editPickupLocation(holdId: any, bibId: any) {
      const dialogInstance = this.$uibModal.open({
         templateUrl: '/assets/libraryCard/editPickupLocationDialog.html',
         controller: 'libraryCardEditPickupLocationController',
         controllerAs: 'vm',
         resolve: {
            holdId: () => holdId,
            bibId: () => bibId
         },
         backdrop: true,
         keyboard: true
      })
      return dialogInstance.result
         .then(() => this.loadHolds())
   }

   updateSelected() {
      this.selectedCount = _.filter(this.docs, (doc: any) => doc.selected).length
      return this.allSelected = this.selectedCount === this.docs.length
   }

   toggle(doc: any) {
      _.each(this.docs, (doc: any) => { return doc.selected = this.allSelected })
      return this.updateSelected()
   }

   cancelHold(id: any) {
      this.success = ''
      this.error = ''
      this.isLoading = true
      const idx = _.findIndex(this.docs, (doc: any) => doc.holdId === id)
      return this.sierraService.deleteHold(id)
         .then((data: any) => { 
            this.docs.splice(idx,1)
            this.$log.debug(' hold succesfully canceled ')
            this.success = this.i18n.translations.REQUESTS_CANCEL_SUCCESS
            this.alerts.pulseAlert('libraryCardSuccess', this.success, 5000)
            this.updateSelected()
            return this.isLoading = false
         }).catch((err: any) => {
            this.$log.error('error canceling hold ', err)
            this.isLoading = false
            if (err.status === 404) {
               this.error = this.i18n.translations.REQUESTS_CANCEL_ERROR_404
               const retryText = this.i18n.translations.PLEASE_RELOAD_TO_TRY_AGAIN
               return this.alerts.pulseAlert('libraryCardListLoadError', this.error, 10000, retryText)
            } else {
               this.error = this.i18n.translations.REQUESTS_CANCEL_ERROR
               return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
            }
         })
   }

   cancelSelectedHolds() {
      this.success = ''
      this.error = ''
      this.isLoading = true
      const selectedDocs = _.filter(this.docs, (doc: any) => doc.selected)
      const holdPromises = _.map(selectedDocs, (doc: any) => {
         return this.sierraService.createAlwaysSuccessPromise(this.sierraService.deleteHold(doc.holdId), doc.holdId)
      })

      const handleResults = (results: any) => { 
         this.isLoading = false
         const successDocs: any = []
         const failedDocsWithError = []
         _.map(results, (result: any) => { 
            if (result.status === 'success') {
               return successDocs.push(result.holdId)
            } else {
               return failedDocsWithError.push({holdId: result.holdId, error: result.original})
            }
         })
      
         if (successDocs.length === selectedDocs.length) {
            this.success = this.i18n.translations.REQUESTS_CANCEL_SUCCESS_ALL
            this.alerts.pulseAlert('libraryCardSuccess', this.success, 5000)
         }
      
         // we leave all the docs that are not 'success' (which means they are deleted)
         this.docs = _.filter(this.docs, (d: any) => !successDocs.includes(d.holdId))
      
         if ((this.docs.length === 0) && (this.success !== this.i18n.translations.REQUESTS_CANCEL_SUCCESS_ALL)) {
            this.success = this.i18n.translations.REQUESTS_EMPTY
            this.alerts.pulseAlert('libraryCardSuccess', this.success, 5000)
         }

         if (failedDocsWithError.length) {
            this.error = this.i18n.translate(this.i18n.translations.REQUESTS_CANCEL_SOME_ERROR, {number: failedDocsWithError.length})
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         }
      }
    
      return this.$q
         .all(holdPromises) 
         .then(handleResults) 
         .catch((errors: any) => { 
            this.error = this.i18n.translations.REQUESTS_CANCEL_ERROR
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }
}

LibraryCardRequestListController.$inject = ['$scope', 'sierraService', 'apiService', 'translationService', 'alertService', '$q', '$log', '$uibModal', '$filter', '$rootScope', '$authEvents', 'libraryCardErrorHelper']

angular.module('summonApp.controllers')
   .controller('libraryCardRequestListController', LibraryCardRequestListController)
